import LinkBadge from './LinkBadge'
export default LinkBadge
